export default __webpack_public_path__ + "static/butterfly-0e5c6debfa004a6910fd9f82481abf58.webp";